import { apiRequest } from '../../services/apiClient';

export function getDriveSettingsBundle() {
  return Promise.all([
    apiRequest('/drive/config'),
    apiRequest('/admin/slack-settings'),
    apiRequest('/admin/assistant-settings'),
  ]);
}

export function getDriveConfig() {
  return apiRequest('/drive/config');
}

export function getAiModels() {
  return apiRequest('/admin/ai-models');
}

export function updateDriveConfig(config) {
  return apiRequest('/drive/config', {
    method: 'PUT',
    json: config,
  });
}

export function getFileBackfillAssessment() {
  return apiRequest('/admin/file-backfill/assess');
}

export function runFileBackfill() {
  return apiRequest('/admin/file-backfill/run', { method: 'POST' });
}

export function getFileBackfillStatus() {
  return apiRequest('/admin/file-backfill/run-status');
}

export function updateSlackSettings(config) {
  return apiRequest('/admin/slack-settings', {
    method: 'PUT',
    json: config,
  });
}

export function updateAssistantSettings(config) {
  return apiRequest('/admin/assistant-settings', {
    method: 'PUT',
    json: config,
  });
}
